import Vue from "vue";
import Vuetify from "vuetify/lib";
import config from "@/config";
import "font-awesome/css/font-awesome.css";
import http from "axios";
import router from "../Routes";
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/src/sweetalert2.scss';
import store from "@/store/index.js"
import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader

window.swal = require('sweetalert2');

Vue.use(Vuetify);
/*
const axios = http.create({
  baseURL: config.baseURL,
  headers: {
    Authorization: "Bearer " +  localStorage.getItem("token"),
    'Cache-Control': 'no-cache',
    'Pragma': 'no-cache',
    'Expires': '0',
  },
});

Vue.prototype.$http = axios;

axios.interceptors.response.use(
  (response) => {

    return response;
  }, (error) => {
    const {
      response: { status, data }
    } = error;

    if (status == '401') {

      window.localStorage.removeItem('token');
      window.localStorage.removeItem('customerid');
      window.localStorage.removeItem('authenticated');

      swal.fire({
        icon: 'error',
        title: 'Token',
        text: 'Token หมดอายุ'
      });

      router.push("/login");

    }
    return Promise.reject(error);
  });

  */

//console.log("Finished.");

export default new Vuetify({
  theme: {
    
    themes: {
      light: config.light,
    },
  },
  icons: {
    iconfont: 'mdi', // default - only for display purposes
  },
});
